import { processQuickBitDeposit } from '@/utils/api';
import Vue from 'vue';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';
import i18n from '@/utils/i18n';

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    depositStatus: {
      loading: false,
      success: false,
      error: false,
      redirect: false,
    },
    bonusClaimed: false,
  };
};
const state = getDefaultState();

const getters = {
  getField,
};
const mutations = {
  updateField,
  setDepositStatus(state, row) {
    state.depositStatus = {
      ...state.depositStatus,
      ...row,
    };
  },
};

const actions = {
  tryDepositQuickBit({ commit, dispatch }, amount) {
    commit('setDepositStatus', {
      loading: true,
      success: false,
      error: false,
      redirect: false,
    });
    commit('depositStore/setPostDepositLoading', true, { root: true });
    processQuickBitDeposit(amount).then(r => {
      commit('depositStore/setPostDepositLoading', false, { root: true });
      if (r.data.IsSuccess && r.data.Data.success) {
        dispatch('player/tryGetBalance', null, { root: true });
        commit('setDepositStatus', {
          error: false,
          success: true,
          redirect: i18n.t('DepositView.OnlineBanking.Redirect'),
        });
        console.log(r.data.Data.success.redirectUrl);
        setTimeout(() => {
          document.location.href = r.data.Data.success.redirectUrl;
        }, 2000);
      } else {
        commit('setDepositStatus', {
          error: i18n.t('DepositView.OnlineBanking.Error'),
          success: false,
          redirect: false,
        });
      }
      commit('setDepositStatus', { loading: false });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
